export const HIRING_V2_MEMBER_ADDED_MODAL = 'HIRING_V2_MEMBER_ADDED_MODAL';
export const HIRING_V2_JOB_BOOST_MODAL = 'HIRING_V2_JOB_BOOST_MODAL';
export const HIRING_V2_JOB_BOOST_NO_BOOST_MODAL =
  'HIRING_V2_JOB_BOOST_NO_BOOST_MODAL';
export const HIRING_V2_NYLAS_SCHEDULER_MODAL =
  'HIRING_V2_NYLAS_SCHEDULER_MODAL';
export const HIRING_V2_SKIP_ADD_MEMBER_TO_TEAM_MODAL =
  'HIRING_V2_SKIP_ADD_MEMBER_TO_TEAM_MODAL';
export const HIRING_V2_SHARE_OPPORTUNITY_MODAL =
  'HIRING_V2_SHARE_OPPORTUNITY_MODAL';

// Nylas Scheduler
export const HIRING_V2_NYLAS_SCHEDULE_INTERVIEW_TOP_MATCH_MODAL =
  'HIRING_V2_NYLAS_SCHEDULE_INTERVIEW_TOP_MATCH_MODAL';
export const HIRING_V2_NYLAS_LINK_TO_SCHEDULE_INTERVIEW_MODAL =
  'HIRING_V2_NYLAS_LINK_TO_SCHEDULE_INTERVIEW_MODAL';
export const HIRING_V2_NYLAS_DECLINE_INTERVIEW_MODAL =
  'HIRING_V2_NYLAS_DECLINE_INTERVIEW_MODAL';
export const HIRING_V2_VERIFY_CANCEL_INTERVIEW_TIMES_MODAL =
  'HIRING_V2_VERIFY_CANCEL_INTERVIEW_TIMES_MODAL';
